export { default } from "./BrandHead";
